/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import Button from '../common/Button';
import AutofillForm from './AutofillForm';
import useAutofill from '../../redux/features/autofill/useAutofill';
import Backdrop from '../backdrop/Backdrop';

export default function AutofillDialog({ procedureId }) {
  const { t } = useTranslation();

  const {
    uiSchema,
    validationSchema,
    submission,
    updateSubmission,
    updateAutofillDialogState,
    onCheckAction,
    dispatchDraftState,
    setUiSchema,
    setIsValid,
    isValid,
    procedure,
    autofillDialogState,
    onFillManuallyAction,
    extraErrors,
    setExtraErrors,
    disableFillManuallyButton,
  } = useAutofill(procedureId);

  return (
    <Dialog data-testid="autofill-dialog" fullWidth maxWidth="lg" open={autofillDialogState.open}>
      <DialogTitle>
        <Typography component="span" variant="h2" gutterBottom>
          {t('submission.epvl.createDialog.title')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('submission.epvl.createDialog.description')) }}
        />
        {autofillDialogState.loading && <Backdrop blocking={true} />}
        <AutofillForm
          testId="autofill-form"
          submission={submission}
          procedure={procedure}
          setIsValid={setIsValid}
          setUiSchema={setUiSchema}
          dispatchDraftState={dispatchDraftState}
          setSubmission={updateSubmission}
          uiSchema={uiSchema}
          validationSchema={validationSchema}
          extraErrors={extraErrors}
          setExtraErrors={setExtraErrors}
        />
      </DialogContent>
      <DialogActions>
        <Button data-testid="cancelAuotfill" color="default" onClick={() => updateAutofillDialogState({ open: false })}>
          {t('actions.cancel')}
        </Button>
        <Button
          data-testid="fillManually"
          color="default"
          disabled={!autofillDialogState.enableFillManually || disableFillManuallyButton}
          onClick={onFillManuallyAction}
        >
          {t('actions.fillManually')}
        </Button>
        <Button
          data-testid="checkInformation"
          color="primary"
          type="submit"
          disabled={!isValid}
          onClick={onCheckAction}
        >
          {t('actions.check')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
